const localStorageKey = 'bobw-houston';

function getAllData() {
	let localStorageData;

	try {
		localStorageData = JSON.parse(localStorage.getItem(localStorageKey));
	} catch (error) {
		localStorageData = null;
	}

	return localStorageData;
}

function removeAllData() {
	localStorage.removeItem(localStorageKey);
}

function getItem(key) {
	return (getAllData() || {})[key];
}

function setItem(key, value) {
	localStorage.setItem(
		localStorageKey,
		JSON.stringify({
			...getAllData(),
			[key]: value,
		}),
	);
}

export default {
	getAllData,
	removeAllData,
	getItem,
	setItem,
};
